import { useI18n } from 'vue-i18n'
import { useFormat } from './format'

/** A sentence the server sends as a code and its values (review B46). */
export type SaidParams = Record<string, string | number | null>
export interface Said { code: string; params?: SaidParams }

/**
 * Writes a server's sentence in the user's language: the key's text with its
 * values (numbers formatted; `count` picks the plural form). Without a code, or
 * with one the screens do not know yet (a newer server), the server's French
 * text shows instead.
 */
export function useSaid() {
  const { t, te } = useI18n()
  const f = useFormat()
  return (key: string | null | undefined, params: SaidParams | undefined, fallback = ''): string => {
    if (!key || !te(key, 'fr')) return fallback
    const values = Object.fromEntries(Object.entries(params ?? {})
      .map(([k, v]) => [k, typeof v === 'number' ? f.number(v, 2) : v ?? '']))
    const count = params?.count
    return typeof count === 'number' ? t(key, values, count) : t(key, values)
  }
}
